import React from "react";
import { isEmpty } from "lodash";
// components
import RMDRComponentSanitizer from "@/components/RMDRComponentSanitizer";
import TopShape01 from "@/components/shapes/TopShape01";
import BottomShape02 from "@/components/shapes/BottomShape02";
import RMDRImage from "@/components/RMDRImage";
// enums
import EResourceType from "@/cms/enums/EResourceType";
import EContentType from "@/cms/enums/EContentType";
// types
import { TMainPageLayoutV2 } from "../type";
import TClientMainPageItemList from "@/cms/types/TClientMainPageItemList";
import TClientMenuItemList from "@/cms/types/TClientMenuItemList";
import TLanguageVersionList from "@/cms/types/TLanguageVersionList";
// utilities
import { mainPageItemNameDescriptionLanguageVersion } from "@/utilities/LanguageVersionSelectorShortcut";


const RenderItems = (props:{ payload?:TClientMenuItemList[]|TClientMainPageItemList[]|null, languageVersionSelector:any, template?:TClientMainPageItemList }) => {
    console.log("MNPG023.RenderItems", props);

    if (!props.payload || isEmpty(props.payload)) return null;

    return props.payload?.map((item, index) => {
        const languageVersion:TLanguageVersionList = props.languageVersionSelector(item.languageVersions);

        return (
            <div
                className="col-xl-3 col-lg-4 col-md-6 "
                data-aos-duration="800"
                data-aos="fade-up"
                data-aos-delay={`${200+(index*200)}`}
            >
                <div className="work-process-items text-center">
                    <div className="icon bg-cover">
                        <RMDRImage 
                            resources={item.resources}
                            resourceType={EResourceType.ICON}
                            alt={languageVersion?.name}
                            title={languageVersion?.name}
                        />
                    </div>
                    <div className="content">
                        <h4>{languageVersion?.name}</h4>
                        <RMDRComponentSanitizer languageVersion={languageVersion} valueExpr="value" variant="p" removeTag />
                    </div>
                </div>
            </div>
        )
    })
}

const Render = (props:TMainPageLayoutV2) => {
    console.log("MNPG023.Render", props);

    const childs = props.templates?.filter((item) => item.mapLayoutName === props.template?.mapLayoutName && ![EContentType.MAP,EContentType.SITE_SETTING].includes(item?.contentType as number) && item.parentId === props.template?.id);
    
    if ( !childs || isEmpty(childs) ) return null;
    return (<RenderItems payload={childs} languageVersionSelector={mainPageItemNameDescriptionLanguageVersion} />)
}


const MNPG023 = ( props: TMainPageLayoutV2 ) => {
    console.log("MNPG023.rendered", props);

    if ( !props.template || isEmpty(props.template) ) return null;
    
    return (
        <section className="section section-padding section-bg-2 fix">
            <TopShape01 />
            <BottomShape02 />
            <div className="container">
                <div className="process-work-wrapper">
                    <div className="row g-4">
                        <Render {...props} />
                    </div>
                </div>
            </div>
        </section>
    )
}

const Component = React.memo(MNPG023, ( prevProps:TMainPageLayoutV2, nextProps:TMainPageLayoutV2 ) => {
    console.log("MNPG023.memo", { prevProps, nextProps });
    return true;
});

export default Component;
